<div class="d-flex justify-content-center mt-4">
  <div *ngIf="isLoading"
       class="spinner-border text-primary"
       style="width: 8rem; height: 8rem;"
       role="status">
    <span class="sr-only">Loading...</span>
  </div>

  <div *ngIf="message" class="alert alert-danger mt-3 text-center">
    {{ message }}
  </div>
</div>

<div class="row mt-5" *ngIf="showDivRouteToHomePage">
  <div class="col-md-12 text-center">
    <a href="/" class="btn btn-primary">Exit to Return to the Settlement Website</a>
  </div>
  <br />
  <br />
  <br />
</div>

